document.addEventListener('click', function(e) {
    const cartSection = document.querySelector('section.cart');
    const cartToggle = document.querySelector('button[aria-label="Bag"]');

    const searchDrawer = document.querySelector('#searchbar');
    const searchToggle = document.querySelector('a.fire-search');
    
    // Ignore clicks on the cart itself or the toggle button
    if (!cartSection.contains(e.target) && !cartToggle.contains(e.target)) {
      document.body.classList.remove('open-cart');
    }

    if (!searchDrawer.contains(e.target) && !searchToggle.contains(e.target)) {
      document.body.classList.remove('open-search');
    }
});